import { FETCH_ALL_PROJECTS_UPDATED } from '../../constants/actionTypes'

export default (projectsCountryDetails = [], action) => {
    switch (action.type) {
        case FETCH_ALL_PROJECTS_UPDATED:
            return action.payload;
        default:
            return projectsCountryDetails;
    }
}